import React, { Component } from 'react';
import FastClone from 'fastest-clone';
import AlertsApiClient from '../stores/AlertsApiClient';

import './Alert.css';

export default class Alert extends Component {
  
  constructor(props) {
    super(props);
    this.state = props.alert != null ? props.alert :
        this.makeState();
  }

  componentWillReceiveProps(props){
    this.setState(props.alert);
  }

  save(name, code, interval, enabled) {
    var self = this;

    var s = self.makeState();
    s.Name = name;
    s.Code = code;
    s.Interval = interval;
    s.Enabled = enabled;
    s.EmailInterval = 600;

    var promise = new AlertsApiClient().create(s).then(function (response) {
        self.setState(response.data);
    });

    promise.catch(function (error) {
      if (error.response.data.errorMessage != null) {
        alert(error.response.data.errorMessage);
      }
    });

    return promise;
  }

  handleEditClick = (e) => {
    window.page.modal.show(this);
  }

  handleDeleteClick = (e) => {
    var self = this;
    new AlertsApiClient().delete(this.state.Key).then(function () {
        self.setState({deleted: true});
        self.props.onDelete(self.state);
    });
  }

  handlePlayClick = (e) => {
    var self = this;
    new AlertsApiClient().run(this.state.Key).then(function (response) {
      self.setState(response.data);
    }).catch(function (error) {
      if (error.response.data.errorMessage != null) {
        alert(error.response.data.errorMessage);
      }
    });
  }

  getTimeSinceLastRun() {
    var txt = this.state.LastRunDate;
    if (txt[txt.length - 1] === 'Z')
      txt = txt.slice(0, -1);
    return parseInt((this.getUtcNow() - new Date(txt)) / 1000, 10);
  }

  getUtcNow() { 
    var now = new Date(); 
    var utc = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(),  now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds());
    return utc;
  }

  makeState() {
      var s = {};

      if (this.state == null) {
        s.Name = '';
        s.Code = '';
        s.Interval = 0;
        s.Enabled = true;
      } else {
        s = new (FastClone.factory(this.state, true))(this.state);
      }

      return s;
  }
  
  render() {
    return (
        <li className="alert list-group-item">
            <span className={"pull-left circle " + (this.state.Enabled ? (this.state.LastResult !== 0 ? "red" : "green") : "gray")}></span>
            <span className="pull-left ml10">{this.state.Name}</span>
            <span className="icon dripicons-trash pull-right ml10" onClick={this.handleDeleteClick}></span>
            <span className="icon dripicons-document-edit pull-right ml10" onClick={this.handleEditClick}></span>
            <span className="icon dripicons-media-play pull-right ml10" onClick={this.handlePlayClick}></span>
            <span className="pull-right ml10">{this.getTimeSinceLastRun()} seconds ago</span>
        </li>
    );
  }

}


// WEBPACK FOOTER //
// ./src/components/Alert.js